/* eslint-disable func-names */
/* eslint-disable eqeqeq */
// eslint-disable-next-line no-undef, no-unused-vars
import jQuery from "jquery";

// eslint-disable-next-line no-unused-vars
const $ = jQuery;

// eslint-disable-next-line no-shadow
(($) => {
    $(".site-footer-main .footer-menu-title-link").on("click", function (e) {
        const windowWidth = $(window).width();
        if (windowWidth < 1139) {
            $(this).parent().find("ul").slideToggle();
            $(this).toggleClass("footer-menu-title-link--accordion-open");
            e.preventDefault();
        }
    });

    $(".site-footer-main .email-input-container input").blur(function () {
        const labelPlaceHolder = $(".email-placeholder");
        if ($(this).val()) {
            $(labelPlaceHolder).addClass("smallLabel");
        } else if ($(labelPlaceHolder).hasClass("smallLabel")) {
            $(labelPlaceHolder).removeClass("smallLabel");
        }
    });

    $('.site-footer-main .subscribe-terms input[type="checkbox"]').change(
        function () {
            const submitButton = $(
                ".site-footer-main .email-input-container button",
            );
            if (this.checked) {
                $(submitButton).prop("disabled", false);
            } else {
                $(submitButton).prop("disabled", true);
            }
        },
    );

    $(".site-footer-main .email-input-container button").on("click", (e) => {
        if ($(".site-footer-main .email-input-container input").val() != "") {
            const selectedGender = $(
                '.gender-style-container input[name="gender"]:checked',
            ).val();
            if (selectedGender != "" && selectedGender != undefined) {
                const newContactTagValue = $(
                    '.site-footer-main input[name="contact[tags]"]',
                ).val();
                $('.site-footer-main input[name="contact[tags]"]').attr(
                    "value",
                    `${newContactTagValue},${selectedGender}`,
                );
                $("#site-footer-newsletter").submit();
            }
            e.preventDefault();
        }
    });
    // eslint-disable-next-line no-undef
})(jQuery);
